import { Button, Grid, FormControl, InputLabel, Select, MenuItem, Divider } from '@material-ui/core';
import { useStyles } from '@webapps/styles';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import Modal from 'components/Modal';
import { useAuth, useToast, useMutation, usePaymentContext } from '@webapps/reactjs-tech-components';
import { upgradeBusiness, stopSubscription, reactivateSubscription } from "@webapps/business";
import {
  useRouter
} from '@webapps/reactjs-tech-components';

import SepaIcon from 'components/Icons/Sepa';
import StripeIcon from 'components/Icons/Stripe';
import SubscriptionFreeIcon from 'components/Icons/SubscriptionFree';
import SubscriptionPremiumIcon from 'components/Icons/SubscriptionPremium';

import Checklist from 'components/Icons/Checklist';
import Cross from 'components/Icons/Cross';

import StripeContainer2 from 'components/StripeContainerUpgrade';
import { ROUTES_PATH } from 'config/constants';

import Invoices from './components/Invoices';

const { NX_REST_API, NX_PROXY_API } = process.env;

const Subscription = ({ accountInfos = [], refetchAccountInfo }) => {

  const { classes, css, global, cx,
    theme: { spacing },


  } = useStyles(styles);
  const { addToast } = useToast();
  const { idUser, setIsPremium, profile } = useAuth();

  const { push } = useRouter();

  const [openModal, setOpenModal] = useState(false);

  const subscription = accountInfos.subscription;
  const paymentType = accountInfos.paymentType;
  const [subscriptionEndDate, setSubscriptionEndDate] = useState(accountInfos.sub_expiration);

  // Allow user to change free to premium account
  const [premiumAsked, askPremium] = useState(false);
  const [toPay, setToPay] = useState(false);

  // State used to control if stripe needs to be displayed
  const [showStripeContainer, setShowStripeContainer] = useState(false);

  // One month subscription price
  // TODO @Arnaud @Quentin @ Mathieu : Define 1 month price for stripe payment
  const monthlyPrice = 36;

  // Define subscription periods : 12 months
  const subscriptionPeriod = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  // Define state for subscription time (from 1 to 12 months), initial : 1 month
  const [subscriptionPeriodSelected, setsubscriptionPeriodSelected] = useState(1);

  // Payment amount context, used to know in real time payment amount
  const { paymentAmount, setPaymentAmount, payment, togglePayment, customerId, setCustomerId } = usePaymentContext();

  useEffect(() => {
    setPaymentAmount(monthlyPrice)
  }, []);

  // State that define subscritpion end date (by default, 1 month after today)
  const dayOfNow = Date.now();
  let initialEndDate = new Date(dayOfNow);
  initialEndDate.setMonth(initialEndDate.getMonth() + 1);


  ////////// STRIPE PAYMENT SUCCESS //////////
  // When payment succeeds on Stripe
  useEffect(() => {
    if (payment === true) {

      // Upgrade subscription with new data
      mutateUpgradeAccount({
        accountId: idUser,
        name: accountInfos.name,
        subscription: "Premium",
        sub_expiration: subscriptionEndDate.toLocaleDateString(),
        gocardlessMandateId: null,
        gocardlessCustomerId: null,
        gocardlessSubscriptionId: null,
      });

      // Mask stripe container
      askPremium(false);
      setToPay(false);
      setShowStripeContainer(false);

      // Reset payment to false
      togglePayment();

      addToast({
        status: 'warning',
        message: (
          <div>Transaction en cours de validation...</div>
        ),
      });
    }
  }, [payment]);


  // Handle changes for subscription time
  const setSubscriptionPeriod = (event) => {
    event.preventDefault();
    // Set selected value into state
    setsubscriptionPeriodSelected(event.target.value);
    // Calculate end date
    let today = Date.now();
    let endDate = new Date(today);
    let numberOfMonths = event.target.value;
    endDate.setMonth(endDate.getMonth() + numberOfMonths);
    // Set end date into state
    setSubscriptionEndDate(endDate);
    // Set payment amout
    setPaymentAmount(monthlyPrice * event.target.value)
  };

  // Function that returns readable end date for user
  function getEndDate() {
    if (subscriptionEndDate !== null) {
      return subscriptionEndDate.toLocaleDateString();
    }
  }

  // Display expiration date in case of Stripe Payment
  function getExpirationDate() {
    if (subscription.toLocaleLowerCase() === 'premium' && paymentType === 'Stripe' && subscriptionEndDate !== '' && subscriptionEndDate !== null) {
      return (
        <p>Votre abonnement expirera le {subscriptionEndDate}</p>
      );
    } else if (subscription.toLocaleLowerCase() === 'premium' && paymentType === 'Stripe' && subscriptionEndDate === '' && subscriptionEndDate !== null) {
      return (
        <div style={{ display: 'block' }}>
          <p>La date de fin de votre abonnement n'est pas connue</p>
        </div>
      );
    } else {

    }
  }


  // Account Upgrade Mutation
  const {
    data: dataUpgradeBusiness,
    error: errorUpgradeBusiness,
    isLoading: isLoadingUpgradeBusiness,
    isSuccess: isSuccessUpgradeBusiness,
    mutate: mutateUpgradeAccount,
  } = useMutation(upgradeBusiness);


  // Handle upgrade success & error
  useEffect(() => {
    if (isSuccessUpgradeBusiness) {
      addToast({
        status: 'success',
        message: (
          <div>
            <div>Paiement reçu</div>
            <div>Abonnement premium confirmé</div>
            <div>Votre compte va être mis à jour</div>
          </div>
        ),
      });
      profile === "BUSINESS" ? push(ROUTES_PATH.BUSINESS_SETTINGS) : push(ROUTES_PATH.SCHOOL_SETTINGS);
      window.location.reload();
    }
    if (errorUpgradeBusiness) {
      addToast({
        status: 'error',
        message: (
          <div>
            <div>Erreur lors de la souscription premium</div>
          </div>
        ),
      });
    }
  }, [isLoadingUpgradeBusiness, isSuccessUpgradeBusiness, errorUpgradeBusiness]);

  // Account Unsubscribe Mutation
  const {
    data: dataStopSubscription,
    error: errorStopSubscription,
    isLoading: isLoadingStopSubscription,
    isSuccess: isSuccessStopSubscription,
    mutate: mutateStopSubscription,
  } = useMutation(stopSubscription);



  // Unsubscribe from GoCardLess
  async function unsubscribe() {
    // Call GoCard to unsubscribe
    const res = await fetch(`${NX_PROXY_API}/unsubscribeGoCardLess`, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      },
      // Send subescription id to server
      body: JSON.stringify({
        subscriptionId: accountInfos.gocardlessSubscriptionId
      })
    });

    // Get subscription after request try
    const subscriptionCancelled = await res.json();

    //if (subscriptionCancelled) {
    const status = subscriptionCancelled.status;
    // If subscription is paused in gocardless, update database & pennylane
    if (status === 'paused') {
      mutateStopSubscription({
        accountId: idUser,
        pennylaneSubscriptionId: accountInfos.pennylaneSubscriptionId,
      });
    }
    //}
  }


  // Handle stop subscription success & error
  useEffect(() => {
    if (isSuccessStopSubscription) {
      addToast({
        status: 'success',
        message: (
          <div>
            <div>Votre abonnement a bien été annulé</div>
            <div>Votre compte va être mis à jour</div>
          </div>
        ),
      });
      setIsPremium(false);
      setOpenModal(false)
      window.location.reload();
    }
    if (errorStopSubscription) {
      addToast({
        status: 'error',
        message: (
          <div>
            <div>Erreur lors de l'annulation de votre abonnement</div>
          </div>
        ),
      });
    }
  }, [isLoadingStopSubscription, isSuccessStopSubscription, errorStopSubscription]);


  // Account Resubscribe Mutation
  const {
    data: dataReactivateSubscription,
    error: errorReactivateSubscription,
    isLoading: isLoadingReactivateSubscription,
    isSuccess: isSuccessReactivateSubscription,
    mutate: mutateReactivateSubscription,
  } = useMutation(reactivateSubscription);


  // Launch resubscribe to GoCardLess
  async function resubscribe() {
    // Call GoCard to unsubscribe
    const res = await fetch(`${NX_PROXY_API}/reactivateGoCardLess`, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      },
      // Send subescription id to server
      body: JSON.stringify({
        subscriptionId: accountInfos.gocardlessSubscriptionId
      })
    });

    // Get subscription after request try
    const subscriptionReactivated = await res.json();


    const status = subscriptionReactivated.status;
    // If subscription is active in gocardless, update database & pennylane
    if (status === 'active') {
      mutateReactivateSubscription({
        accountId: idUser,
        pennylaneSubscriptionId: accountInfos.pennylaneSubscriptionId,
      });
      //window.location.reload();
    }
  }


  // Handle stop subscription success & error
  useEffect(() => {
    if (isSuccessReactivateSubscription) {
      addToast({
        status: 'success',
        message: (
          <div>
            <div>Votre abonnement a bien été réactivé</div>
            <div>Votre compte va être mis à jour</div>
          </div>
        ),
      });
      setIsPremium(true);
      window.location.reload();
    }
    if (errorReactivateSubscription) {
      addToast({
        status: 'success',
        message: (
          <div>
            <div>Erreur lors de la réactivation de votre abonnement</div>
          </div>
        ),
      });
    }
  }, [isLoadingReactivateSubscription, isSuccessReactivateSubscription, errorReactivateSubscription]);

  // Redirect user to GoCardLess subsciption page
  async function launchGoCardLess() {

    // Create the PaymentIntent calling server
    const res = await fetch(`${NX_PROXY_API}/upgradeWithGocardless`, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      },
      // Send data to create SEPA mandate (total amount, user email, number of months)
      body: JSON.stringify({
        sepaAmount: profile === "BUSINESS" ? '3000' : '30000',
        userEmail: accountInfos.email,
        numberOfMonths: '',
        companyName: accountInfos.name,
        type: profile === "BUSINESS" ? 'entreprise' : 'etablissement',
        userId: idUser,
      })
    });

    // Retrieve payment link & mandate number after this request
    const mandateData = await res.json();

    // Function that open payment link in new navigator tab
    const openInNewTab = (url) => {
      window.open(url, "_blank", "noreferrer");
    };

    // Get mandate data
    if (mandateData) {
      const authorisation_url = mandateData.authorisation_url;
      const customer_id = mandateData.customer_id;

      // Get & store mandate customer id to handle next Gocardless payment status
      if (customer_id) {
        openInNewTab(authorisation_url);
        setCustomerId('"' + customer_id + '"');
      }
    }
  }

  // Change payment method (Stripe <-> GoCardLess)
  const changePaymentMethod = () => {
    switch (paymentType) {
      case 'Stripe': launchGoCardLess();
        break;
      case 'GoCardLess': setShowStripeContainer(true);
        break;
    }
  }

  const handleToPay = () => {
    profile === "BUSINESS" ? setToPay(true) : launchGoCardLess();
  }



  ///// REDIRECTION WHEN GOCARDLESS PAYMENT
  // URL search params
  const query = new URLSearchParams(location.search);

  const mail = query.get('email');
  const id = query.get('id');
  const company = query.get('company');
  const userId = query.get('userId');

  // Subscribe to recurrent payment
  async function registerUser() {

    // Create the Subscription, server call
    const res = await fetch(`${NX_PROXY_API}/goCardLess-subscribe`, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        sepaAmount: '3000',
        userEmail: mail,
        customerId: id,
        type: 'entreprise',
      })
    });

    // Here we can find all details about customer
    // TODO @Benoit -> retrieve and send data to api, in order to register entity (school / business)
    // CARE !!! Data was deleted from state because gocardless open new tab
    const subscription = await res.json();


    // If Subscription in Gocardless is OK, update database & pennylane
    // If Subscription in Gocardless is OK, update database & pennylane
    if (subscription.id !== null) {
      const gocardId = subscription.metadata.customerId;
      const gocardSubId = subscription.id;
      const mandateId = subscription.links.mandate;

      mutateUpgradeAccount({
        accountId: userId,
        name: company,
        subscription: "Premium",
        sub_expiration: null,
        gocardlessMandateId: mandateId,
        gocardlessCustomerId: gocardId,
        gocardlessSubscriptionId: gocardSubId,
      });
    }
  }


  // Add toast when SEPA payment succeeds on account creation
  // Used after redirection when payment succeeds
  useEffect(() => {

    // If payment succeeds, create monthly subscription
    if (location.search.includes('payment=success')) {
      registerUser();
      addToast({
        status: 'success',
        message: (
          <div>
            <div>Mandat SEPA reçu</div>
            <div>Abonnement premium confirmé</div>
            <div>Votre compte va être mis à jour</div>
          </div>
        ),
      });
    };
  }, []);

  return (
    <>
      <Grid spacing={3} xs={12} className={classes.container}>
        <Grid item md={6} className={classes.card}>
          <div style={{ marginBottom: spacing(2.5) }} className={global.title}>Découvrez nos formules</div>
          <div className={classes.subscriptionContainer}>
            <div className={subscription?.toLowerCase() === 'free' ? classes.subscriptionCardSelected : classes.subscriptionCard}>
              {subscription?.toLowerCase() === 'free' && (
                <Checklist className={classes.iconCard} />
              )}
              <h1 className={classes.subscriptionh1}>DÉCOUVERTE</h1>
              <SubscriptionFreeIcon className={classes.subscriptionIcon} />
              <h2 className={classes.subscriptionh2}>0,00€</h2>
              <h3 className={`${classes.subscriptionh3} ${css({ fontWeight: '400' })}`}>Sans frais caché</h3>
              {subscription?.toLowerCase() === 'free' && (
                <div className={classes.buttonSelected}> Formule actuelle </div>
              )}
            </div>
            <div className={subscription?.toLowerCase() === 'premium' ? classes.subscriptionCardSelected : classes.subscriptionCard}>
              {subscription?.toLowerCase() === 'premium' && (
                <Checklist className={classes.iconCard} />
              )}
              <h1 className={classes.subscriptionh1}>PREMIUM</h1>
              <SubscriptionPremiumIcon className={classes.subscriptionIcon} />
              <h2 className={classes.subscriptionh2}>{profile === "BUSINESS" ? '30,00€' : '300,00€'}</h2>
              <h3 className={`${classes.subscriptionh3} ${css({ fontWeight: '400' })}`}>HT / Par mois</h3>
              {subscription?.toLowerCase() === 'premium' ? (
                <div className={classes.buttonSelected}> Formule actuelle </div>
              ) : (
                <div className={classes.buttonUpgrade} onClick={() => { askPremium(true) }} > Voir la formule </div>
              )}
            </div>
          </div>
        </Grid>
        <Grid item md={6} className={classes.card}>
          <div style={{ marginBottom: spacing(2.5) }} className={global.title}>Récapitulatif d'abonnement</div>
          {subscription?.toLowerCase() === 'free' && toPay && profile === 'BUSINESS' ? (
            <div className={classes.subscriptionContainer}>
              {showStripeContainer ? (
                <Grid item xs={12}>
                  <FormControl required fullWidth variant="outlined" >
                    <InputLabel id="subscription-period" className={classes.label}>Durée d'abonnement</InputLabel>
                    <Select
                      labelId="subscription-period"
                      id="subscription-month"
                      value={subscriptionPeriodSelected}
                      onChange={setSubscriptionPeriod}
                      onLoad={setSubscriptionPeriod}
                    >
                      {subscriptionPeriod && (
                        subscriptionPeriod.map(month => (
                          <MenuItem value={month}
                            key={month}
                          >
                            {month} mois
                          </MenuItem>
                        )))}
                    </Select>
                  </FormControl>
                  <p style={{ color: "black" }}>Les abonnements par carte bancaire ne sont pas récurrents, le prix fixe mensuel est de {monthlyPrice} €</p>
                  <p style={{ color: "black" }}>Au paiement, il vous sera demandé de régler la totalité du nombre de mois d'abonnement pris,
                    soit <span style={{ fontWeight: 600, color: "red" }}>{paymentAmount} €</span>, et il prendra fin le {getEndDate()}</p>
                  <StripeContainer2 />
                </Grid>

              ) : (
                <>
                  <div className={classes.subscriptionCard}>
                    <h1 className={classes.subscriptionh1}>MANDAT SEPA</h1>
                    <SepaIcon className={classes.subscriptionIcon} />
                    <h3 className={classes.subscriptionh3}>Paiement mensuel automatiquement reconductible.</h3>
                    <div className={classes.buttonUpgrade} onClick={launchGoCardLess} > {!accountInfos.gocardlessSubscriptionId ? 'Payer avec mandat' : 'Nouveau mandat'} </div>
                    {accountInfos.gocardlessSubscriptionId && (
                      <div className={`${classes.buttonUpgrade} ${css({ marginTop: '8px' })}`} onClick={resubscribe} > Reactiver le mandat </div>
                    )}
                  </div>
                  <div className={classes.subscriptionCard}>
                    <h1 className={classes.subscriptionh1}>CARTE BANCAIRE</h1>
                    <StripeIcon className={classes.subscriptionIcon} />
                    <h3 className={classes.subscriptionh3}>Paiement one-shot sur un ou plusieurs mois non reconductible.</h3>
                    <div className={classes.buttonUpgrade} onClick={() => { setSubscriptionEndDate(initialEndDate); setShowStripeContainer(true); }} > Payer avec carte bancaire </div>
                  </div>
                </>
              )}
            </div>
          ) : (
            <>
              {premiumAsked ? (
                <h1 className={classes.reminderSpan}>En choisissant cette offre, vous aurez accès à :</h1>
              ) : (
                <div className={css({ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap' })}>
                  <div>
                    <p className={classes.reminderHeader}>Abonnement : <span className={classes.reminderSpan}>{subscription?.toLowerCase() === "free" && 'DÉCOUVERTE' || paymentType === 'gift' && 'PREMIUM (Offert par Linkpick)' || subscription?.toLowerCase() === "premium" && 'PREMIUM'}</span></p>
                    <p className={classes.reminderHeader}>Engagement : <span className={classes.reminderSpan}>{subscription?.toLowerCase() === "free" && 'Sans engagement' || (paymentType === 'gift' || paymentType === 'Stripe') && `Jusqu'au ${accountInfos.sub_expiration}` || 'Mensuel'}</span></p>
                  </div>
                  {subscription?.toLowerCase() === "premium" && (
                    <Button color="primary" variant='contained' className={classes.btnCancel} onClick={() => { setOpenModal(true) }}> Arrêter l'abonnement ? </Button>
                  )}
                </div>
              )}
              <div className={classes.reminderContainer}>
                <div className={css({ display: 'flex', flexWrap: 'wrap' })}>
                  <p className={classes.offerList}><Checklist className={classes.icon} /> Tableau de bord</p>
                  <p className={classes.offerList}><Checklist className={classes.icon} /> Vitrine</p>
                  <p className={classes.offerList}><Checklist className={classes.icon} /> {profile === "BUSINESS" ? (subscription?.toLowerCase() === "premium" || premiumAsked ? 'Emplois & Candidats (Illimité)' : 'Emplois & Candidats (1 offre)') : 'Formations & Candidats'}</p>
                  <p className={classes.offerList}>{(subscription?.toLowerCase() === "premium" || premiumAsked) ? <Checklist className={classes.icon} /> : <Cross className={classes.icon} />} CVThèque</p>
                  <p className={classes.offerList}>{(subscription?.toLowerCase() === "premium" || premiumAsked) ? <Checklist className={classes.icon} /> : <Cross className={classes.icon} />} Affiliations</p>
                  <p className={classes.offerList}>{(subscription?.toLowerCase() === "premium" || premiumAsked) ? <Checklist className={classes.icon} /> : <Cross className={classes.icon} />} Partenaires</p>
                  <p className={classes.offerList}>{(subscription?.toLowerCase() === "premium" || premiumAsked) ? <Checklist className={classes.icon} /> : <Cross className={classes.icon} />} {profile === "BUSINESS" ? 'Equipes' : 'Classes'}</p>
                  <p className={classes.offerList}>{(subscription?.toLowerCase() === "premium" || premiumAsked) ? <Checklist className={classes.icon} /> : <Cross className={classes.icon} />} Documents</p>
                  <p className={classes.offerList}><Checklist className={classes.icon} /> Besoin d'aide</p>
                </div>
              </div>
              <div className={classes.reminderContainer}>
                <div className={classes.reminderTextContainer}>
                  <p className={classes.reminderText}>Sous total <span className={classes.reminderSpan}>(HT/an)</span></p>
                  <p className={classes.reminderPrice}>{(subscription?.toLowerCase() === "premium" && paymentType !== "gift") ? (profile === "BUSINESS" ? '30,00€' : '300,00€') : (premiumAsked ? (profile === "BUSINESS" ? '30,00€' : '360,00€') : '0,00€')}</p>
                </div>
                <div className={classes.reminderTextContainer}>
                  <p className={classes.reminderText}>TVA - FR <span className={classes.reminderSpan}>(20%)</span></p>
                  <p className={classes.reminderPrice}>{(subscription?.toLowerCase() === "premium" && paymentType !== "gift") ? (profile === "BUSINESS" ? '6,00€' : '60,00€') : (premiumAsked ? (profile === "BUSINESS" ? '6,00€' : '60,00€') : '0,00€')}</p>
                </div>
                <Divider className={css({ margin: "16px 0" })}></Divider>
                <div className={classes.reminderTextContainer}>
                  <p className={classes.reminderText}>Total <span className={classes.reminderSpan}>(TTC/mois)</span></p>
                  <p className={classes.reminderPriceBIG}>{(subscription?.toLowerCase() === "premium" && paymentType !== "gift") ? (profile === "BUSINESS" ? '36,00€' : '360,00€') : (premiumAsked ? (profile === "BUSINESS" ? '36,00€' : '360,00€') : '0,00€')}</p>
                </div>
              </div>
              {premiumAsked && (
                <div className={classes.reminderTextContainer}>
                  <div className={`${classes.buttonUpgrade} ${classes.buttonWidth}`} onClick={() => { handleToPay() }} > Payer </div>
                  <div className={`${classes.buttonCancel} ${classes.buttonWidth}`} onClick={() => { askPremium(false) }} > Annuler </div>
                </div>
              )}
            </>)}
        </Grid>
        <Grid item md={12} className={classes.card}>
          <div style={{ marginBottom: spacing(2.5) }} className={global.title}>Mes dernières factures</div>
          <Invoices accountInfos={accountInfos} refetchAccountInfo={refetchAccountInfo} />
        </Grid>
        <Modal
          withStep={false}
          onCancel={() => setOpenModal(false)}
          open={openModal}
          title="Résilier votre abonnement ?"
        >
          {paymentType?.toLowerCase() === 'gocardless' ? (
            <div className={css({ textAlign: 'center', fontSize: '13.500px', color: "#152652" })}>
              Voulez-vous vraiment résilier votre abonnement ? <br />Cette action est irréversible et vous perdrez l'accès à tous les services associés à partir du moment de la résiliation.
              <div className={classes.modalContentButtons}>
                <Button
                  className={classes.btnCancel}
                  color="primary"
                  onClick={() => unsubscribe()}
                  variant="contained"
                >
                  Confirmer
                </Button>
                <Button
                  className={classes.modalContentButton}
                  color="primary"
                  onClick={() => setOpenModal(false)}
                  variant="contained"
                >
                  Annuler
                </Button>
              </div>
            </div>
          ) : (
            <div className={css({ textAlign: 'center', fontSize: '13.500px', color: "#152652" })}>
              {paymentType === "gift" ? "Un compte premium Linkpick vous a été offert, vous ne pouvez pas résilier votre abonnement." : "Vous ne pouvez pas résilier un abonnement par carte bancaire. Si cet achat a été effectué par erreur, veuillez contacter support@linkpick.fr"}
              <div className={classes.modalContentButtons}>
                <Button
                  color="primary"
                  onClick={() => setOpenModal(false)}
                  variant="contained"
                  className={classes.buttonUpgrade}
                >
                  D'accord
                </Button>
              </div>
            </div>
          )}
        </Modal>
      </Grid>
    </>
  );
};

const styles = ({ spacing }) => ({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    fontFamily: 'Montserrat',
  },
  subscriptionContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: '#F3F7FF',
    borderRadius: '10px',
    padding: spacing(2),
    minHeight: '92%',
    flexWrap: 'wrap',
  },
  subscriptionCard: {
    backgroundColor: '#FFFFFF',
    borderRadius: '10px',
    border: '1px solid #C0D9FF',
    width: '48.5%',
    flexBasis: '48.5%',
    padding: spacing(2.5),
    textAlign: 'center',
    transition: '0.3s',
    '&:hover': {
      border: '1px solid #0060F9',
      transition: '0.3s',
      backgroundColor: "#C0D9FF"
    },
    '@media only screen and (max-width:630px)': { width: '100%', flexBasis: '100%', marginBottom: '16px' },
  },
  subscriptionCardCancel: {
    backgroundColor: '#FFFFFF',
    borderRadius: '10px',
    border: '1px solid #C0D9FF',
    width: '48.5%',
    flexBasis: '48.5%',
    padding: spacing(2.5),
    textAlign: 'center',
    transition: '0.3s',
    '&:hover': {
      border: '1px solid #F50057',
      transition: '0.3s',
    },
    '@media only screen and (max-width:630px)': { width: '100%', flexBasis: '100%' },
  },
  subscriptionCardSelected: {
    position: 'relative',
    backgroundColor: '#FFFFFF',
    borderRadius: '10px',
    border: '1px solid #76D26B',
    width: '48.5%',
    flexBasis: '48.5%',
    padding: spacing(2.5),
    textAlign: 'center',
    '@media only screen and (max-width:630px)': { width: '100%', flexBasis: '100%' },
  },
  subscriptionh1: {
    margin: '0',
    '@media only screen and (max-width:1920px)': { fontSize: '15.0px' },
    '@media only screen and (max-width:1600px)': { fontSize: '15px' },
    fontWeight: 600,
  },
  subscriptionh2: {
    margin: '0',
    '@media only screen and (max-width:1920px)': { fontSize: '24px' },
    '@media only screen and (max-width:1600px)': { fontSize: '15.00px' },
    '@media only screen and (max-width:1200px)': { fontSize: '13.500px' },
    fontWeight: 600,
  },
  subscriptionh3: {
    margin: spacing(1, 0, 3, 0),
    fontWeight: 400,
    color: '#5D75A8',
    '@media only screen and (max-width:1920px)': { fontSize: '14px' },
    '@media only screen and (max-width:1600px)': { fontSize: '10px' },
    fontFamily: 'Roboto'
  },
  subscriptionIcon: {
    margin: spacing(1, 0),
    width: '52px',
    height: '52px',
  },
  reminderContainer: {
    padding: spacing(2),
    border: '1px solid #C0D9FF',
    borderRadius: '10px',
    marginTop: spacing(2.5),
  },
  reminderTextContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  reminderText: {
    margin: spacing(1, 0),
    color: '#5D75A8',
    '@media only screen and (max-width:1920px)': { fontSize: '14px' },
    '@media only screen and (max-width:1600px)': { fontSize: '10px' },
    fontWeight: 600,
  },
  reminderHeader: {
    color: '#152652',
  },
  reminderSpan: {
    fontFamily: 'Roboto',
    fontWeight: 400,
    color: '#5D75A8',
  },
  reminderPrice: {
    color: '#152652',
    margin: spacing(1, 0),
    fontWeight: 600,
    '@media only screen and (max-width:1920px)': { fontSize: '15.00px' }, '@media only screen and (max-width:1600px)': { fontSize: '14.00px' },
  },
  reminderPriceBIG: {
    color: '#152652',
    margin: spacing(1, 0),
    fontWeight: 600,
    '@media only screen and (max-width:1920px)': { fontSize: '24px' },
    '@media only screen and (max-width:1600px)': { fontSize: '15.00px' },
    '@media only screen and (max-width:1200px)': { fontSize: '13.500px' },
  },
  buttonWidth: {
    width: '48%',
    textAlign: 'center',
    marginTop: spacing(2),
  },
  buttonCancel: {
    cursor: 'pointer',
    padding: '10px',
    borderRadius: '10px',
    border: '1px solid #F50057',
    backgroundColor: '#fbd3d5',
    color: '#F50057',
    transition: '0.3s',
    fontFamily: 'Roboto',
    '&:hover': {
      transition: '0.3s',
    }
  },
  buttonSelected: {
    padding: '10px',
    borderRadius: '10px',
    border: '1px solid #76D26B',
    backgroundColor: '#DBFAD8',
    color: '#76D26B',
    fontFamily: 'Roboto',
    '@media only screen and (max-width:1920px)': { fontSize: '15.00px' },
    '@media only screen and (max-width:1600px)': { fontSize: '14.00px' },
  },
  buttonUpgrade: {
    cursor: 'pointer',
    padding: '10px',
    borderRadius: '10px',
    backgroundColor: '#0060F9',
    color: 'white',
    fontFamily: 'Roboto',
    transition: '0.3s',
    '&:hover': {
      transition: '0.3s',
      backgroundColor: 'rgb(0, 67, 174)',
    },
    '@media only screen and (max-width:1920px)': { fontSize: '15.00px' },
    '@media only screen and (max-width:1600px)': { fontSize: '14.00px' },
  },
  card: {
    backgroundColor: '#FFFFFF',
    borderRadius: '10px',
    width: '49%',
    flexBasis: '49%',
    padding: spacing(2.5),
    marginBottom: "2%",
    '@media only screen and (max-width:1023px)': { width: '100%', flexBasis: '100%' },
  },
  cgu: {
    color: '#0060F9',
    marginLeft: 16,
    padding: '16px 0',
    alignSelf: 'self-end',
    '@media only screen and (max-width:1023px)': { alignSelf: 'self-start', marginLeft: 0 },
  },
  label: {
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' }, '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
    fontWeight: 600,
    color: '#152652',
  },
  password: {
    marginLeft: spacing(2.5),
    marginBottom: spacing(2.5),
  },
  textfield: {
    marginBottom: spacing(2.5),
  },
  infoBox: {
    borderRadius: '5px',
    color: '#152652',
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' }, '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
    fontFamily: 'Montserrat',
    height: '30px',
    backgroundColor: '#F3F7FF',
    display: 'flex',
    alignItems: 'center',
  },
  infoBoxDisabled: {
    borderRadius: '5px',
    color: '#5D75A8',
    backgroundColor: '#FFFFFF',
  },
  icon: {
    width: '24px',
    marginRight: '8px',
  },
  iconCard: {
    position: 'absolute',
    top: '16px',
    right: '16px',
  },
  offerList: {
    display: 'flex',
    alignItems: 'center',
    color: '#5D75A8',
    width: '33%',
    fontFamily: 'Roboto',
    margin: spacing(1, 0),
    '@media (max-width:630px)': { width: '50%' },
  },
  btnCancel: {
    marginLeft: spacing(2),
    backgroundColor: 'crimson',
    '@media only screen and (max-width:1920px)': { fontSize: '15.00px' },
    '@media only screen and (max-width:1600px)': { fontSize: '14.00px' },
  },
  btnDelete: {
    marginTop: spacing(2.5),
    float: 'right',
    backgroundColor: 'crimson',
    '@media only screen and (max-width:1920px)': { fontSize: '15.00px' },
    '@media only screen and (max-width:1600px)': { fontSize: '14.00px' },
  },
  deleteAccount: {
    textAlign: 'center',
    marginBottom: '16px',
    width: '100%',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  btnLogout: {
    marginTop: spacing(2.5),
    backgroundColor: 'white'
  },
  btnLogoutContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'self-end',
  },
  btnsContainer2: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  modalContentButtons: {
    display: 'flex',
    justifyContent: 'space-around',
    marginTop: spacing(3),
  },
});

Subscription.propTypes = {
  accountInfos: PropTypes.object,
  refetchAccountInfo: PropTypes.func,
};

export default Subscription;
